// ANCHOR React
import { memo } from 'react';

// ANCHOR Base
import { SIZE, ROLE } from 'baseui/modal';

// ANCHOR Model
import { useUpdateFormModalVisibilityStateAndHide } from '@lyon/scoped-models/form/update/UpdateFormModalVisibility';
import { FormData, useFormData } from '@lyon/scoped-models/form/FormData';
import { FormQuestionsData } from '@lyon/scoped-models/form/FormQuestionsData';
import { UpdateFormForm } from '@lyon/scoped-models/form/update/UpdateFormForm';
import { MobileView } from '@lyon/scoped-models/MobileView';

// ANCHOR Components
import { CloseModal } from '@lyon/components/utils/CloseModal';
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { LyonUpdateFormDesktopOnly } from './LyonUpdateFormDesktopOnly';
import { LyonUpdateFormBody } from './LyonUpdateFormBody';

// ANCHOR Styles
import { MODAL } from './styles';

interface IProps {
  id: string;
}

const LyonUpdateFormModalBody = constant(() => {
  const form = useFormData();
  const isMobile = MobileView.useSelector((state) => state.isMobile);

  if (!form) {
    return <Loader />;
  }

  return (
    <UpdateFormForm.Provider initialData={form}>
      <FormQuestionsData.Provider id={form.id}>
        {
          isMobile
            ? <LyonUpdateFormDesktopOnly />
            : <LyonUpdateFormBody />
        }
      </FormQuestionsData.Provider>
    </UpdateFormForm.Provider>
  );
});

export const LyonUpdateForm = memo(({ id }: IProps) => {
  const [opened, close] = useUpdateFormModalVisibilityStateAndHide();

  return (
    <CloseModal
      isOpen={opened}
      size={SIZE.full}
      onClose={close}
      role={ROLE.dialog}
      animate
      closeable
      overrides={MODAL}
    >
      <FormData.Provider id={id}>
        <LyonUpdateFormModalBody />
      </FormData.Provider>
    </CloseModal>
  );
});
